import 'survey-core/survey-core.min.css';
import { Model, Survey, SurveyModel } from 'survey-react-ui';
import { useEffect, useRef, useState } from 'react';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ISurveyJSCssClass } from '@vivli/shared/infrastructure/interface';
import { ITheme } from 'survey-core';
import './survey-js.style.css';

export const themeJson: ITheme = {
    themeName: 'plain',
    colorPalette: 'light',
    isPanelless: true,
    backgroundImage: '',
    backgroundImageFit: 'cover',
    backgroundImageAttachment: 'scroll',
    backgroundOpacity: 1,
    cssVariables: {
        '--sjs-font-family': 'Open Sans',
        '--sjs-font-size': '14.4px',
        '--sjs-corner-radius': '4px',
        '--sjs-base-unit': '8px',
        '--sjs-shadow-small': '0px 0px 0px 1px rgba(0, 0, 0, 0.15)',
        '--sjs-shadow-inner': '0px 0px 0px 1px rgba(0, 0, 0, 0.15)',
        '--sjs-border-default': 'rgba(0, 0, 0, 0.15)',
        '--sjs-border-light': 'rgba(0, 0, 0, 0.15)',
        '--sjs-general-backcolor': 'rgba(255, 255, 255, 1)',
        '--sjs-general-backcolor-dark': 'rgba(248, 248, 248, 1)',
        '--sjs-general-backcolor-dim-light': 'rgba(255, 255, 255, 1)',
        '--sjs-general-backcolor-dim-dark': 'rgba(243, 243, 243, 1)',
        '--sjs-general-forecolor': 'rgba(0, 0, 0, 0.91)',
        '--sjs-general-forecolor-light': 'rgba(0, 0, 0, 0.45)',
        '--sjs-general-dim-forecolor': 'rgba(0, 0, 0, 0.91)',
        '--sjs-general-dim-forecolor-light': 'rgba(0, 0, 0, 0.45)',
        '--sjs-secondary-backcolor': 'rgba(255, 152, 20, 1)',
        '--sjs-secondary-backcolor-light': 'rgba(255, 152, 20, 0.1)',
        '--sjs-secondary-backcolor-semi-light': 'rgba(255, 152, 20, 0.25)',
        '--sjs-secondary-forecolor': 'rgba(255, 255, 255, 1)',
        '--sjs-secondary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
        '--sjs-shadow-small-reset': '0px 0px 0px 0px rgba(0, 0, 0, 0.15)',
        '--sjs-shadow-medium': '0px 0px 0px 1px rgba(0, 0, 0, 0.1)',
        '--sjs-shadow-large': '0px 8px 16px 0px rgba(0, 0, 0, 0.05)',
        '--sjs-shadow-inner-reset': '0px 0px 0px 0px rgba(0, 0, 0, 0.15)',
        '--sjs-border-inside': 'rgba(0, 0, 0, 0.16)',
        '--sjs-special-red-forecolor': 'rgba(255, 255, 255, 1)',
        '--sjs-special-green': 'rgba(25, 179, 148, 1)',
        '--sjs-special-green-light': 'rgba(25, 179, 148, 0.1)',
        '--sjs-special-green-forecolor': 'rgba(255, 255, 255, 1)',
        '--sjs-special-blue': 'rgba(67, 127, 217, 1)',
        '--sjs-special-blue-light': 'rgba(67, 127, 217, 0.1)',
        '--sjs-special-blue-forecolor': 'rgba(255, 255, 255, 1)',
        '--sjs-special-yellow': 'rgba(255, 152, 20, 1)',
        '--sjs-special-yellow-light': 'rgba(255, 152, 20, 0.1)',
        '--sjs-special-yellow-forecolor': 'rgba(255, 255, 255, 1)',
        '--sjs-article-font-xx-large-textDecoration': 'none',
        '--sjs-article-font-xx-large-fontWeight': '700',
        '--sjs-article-font-xx-large-fontStyle': 'normal',
        '--sjs-article-font-xx-large-fontStretch': 'normal',
        '--sjs-article-font-xx-large-letterSpacing': '0',
        '--sjs-article-font-xx-large-lineHeight': '64px',
        '--sjs-article-font-xx-large-paragraphIndent': '0px',
        '--sjs-article-font-xx-large-textCase': 'none',
        '--sjs-article-font-x-large-textDecoration': 'none',
        '--sjs-article-font-x-large-fontWeight': '700',
        '--sjs-article-font-x-large-fontStyle': 'normal',
        '--sjs-article-font-x-large-fontStretch': 'normal',
        '--sjs-article-font-x-large-letterSpacing': '0',
        '--sjs-article-font-x-large-lineHeight': '56px',
        '--sjs-article-font-x-large-paragraphIndent': '0px',
        '--sjs-article-font-x-large-textCase': 'none',
        '--sjs-article-font-large-textDecoration': 'none',
        '--sjs-article-font-large-fontWeight': '700',
        '--sjs-article-font-large-fontStyle': 'normal',
        '--sjs-article-font-large-fontStretch': 'normal',
        '--sjs-article-font-large-letterSpacing': '0',
        '--sjs-article-font-large-lineHeight': '40px',
        '--sjs-article-font-large-paragraphIndent': '0px',
        '--sjs-article-font-large-textCase': 'none',
        '--sjs-article-font-medium-textDecoration': 'none',
        '--sjs-article-font-medium-fontWeight': '700',
        '--sjs-article-font-medium-fontStyle': 'normal',
        '--sjs-article-font-medium-fontStretch': 'normal',
        '--sjs-article-font-medium-letterSpacing': '0',
        '--sjs-article-font-medium-lineHeight': '32px',
        '--sjs-article-font-medium-paragraphIndent': '0px',
        '--sjs-article-font-medium-textCase': 'none',
        '--sjs-article-font-default-textDecoration': 'none',
        '--sjs-article-font-default-fontWeight': '400',
        '--sjs-article-font-default-fontStyle': 'normal',
        '--sjs-article-font-default-fontStretch': 'normal',
        '--sjs-article-font-default-letterSpacing': '0',
        '--sjs-article-font-default-lineHeight': '28px',
        '--sjs-article-font-default-paragraphIndent': '0px',
        '--sjs-article-font-default-textCase': 'none',
        '--sjs-general-backcolor-dim': 'rgba(255, 255, 255, 1)',
        '--sjs-primary-backcolor': 'rgba(37, 137, 229, 1)',
        '--sjs-primary-backcolor-dark': 'rgba(21, 119, 209, 1)',
        '--sjs-primary-backcolor-light': 'rgba(37, 137, 229, 0.1)',
        '--sjs-primary-forecolor': 'rgba(255, 255, 255, 1)',
        '--sjs-primary-forecolor-light': 'rgba(255, 255, 255, 0.25)',
        '--sjs-special-red': 'rgba(229, 10, 62, 1)',
        '--sjs-special-red-light': 'rgba(229, 10, 62, 0.1)',
    },
    header: {
        height: 0,
        mobileHeight: 0,
        inheritWidthFrom: 'survey',
        textAreaWidth: 0,
        backgroundImageFit: 'cover',
        backgroundImageOpacity: 100,
        overlapEnabled: false,
        logoPositionX: 'left',
        logoPositionY: 'top',
        titlePositionX: 'left',
        titlePositionY: 'bottom',
        descriptionPositionX: 'left',
        descriptionPositionY: 'bottom',
    },
    headerView: 'advanced',
};

interface ISurveyJSComponentProps {
    questions: any;
    answers?: string;
    setSurveyHasErrors?: (hasErrors: boolean) => void;
    onChange?: (answers: any) => any;
    includeRiskScore?: boolean;
    showCompleteButton?: boolean;
    readonly?: boolean;
    questionCssClasses?: ISurveyJSCssClass[];
}

export const SurveyJsComponent = ({
    questions,
    answers,
    onChange,
    setSurveyHasErrors,
    includeRiskScore = false,
    showCompleteButton = false,
    readonly = false,
    questionCssClasses,
}: ISurveyJSComponentProps) => {
    const debounceRef = useRef(new Subject<SurveyModel>());
    const [survey, setSurvey] = useState<Model>();

    useEffect(() => {
        if (!questions) {
            return;
        }

        // build survey model
        const surveyModel = new Model(questions);

        // set survey model options
        surveyModel.readOnly = readonly;
        surveyModel.showInvisibleElements = false;
        surveyModel.applyTheme(themeJson);
        surveyModel.description = '';

        // set survey data
        if (answers?.length > 0) {
            surveyModel.data = JSON.parse(answers);
        }

        // override css classes for custom styling
        if (questionCssClasses) {
            surveyModel.onUpdateQuestionCssClasses.add((_, options) => {
                const questionType = options.question.getType();
                const customCssClass = questionCssClasses?.find((x) => x.type === questionType);

                if (customCssClass) {
                    options.cssClasses = customCssClass;
                }
            });
        }

        setSurvey(surveyModel);
    }, [questions]);

    useEffect(() => {
        // don't fire onchange events if not passed in
        if (!onChange || !survey) {
            return;
        }

        setSurveyHasErrors(!survey.validate());
        
        survey.onValueChanged.add((result, options) => {
            debounceRef.current.next(result);
        });

        // Debounce survey typed answers so we're not spamming onChange updates
        const debounceSubscription = debounceRef.current.pipe(debounceTime(500)).subscribe((value) => {
            // Fire onChange with answer values
            setSurveyHasErrors(!survey.validate());
            onChange(survey.data);
        });

        return () => {
            debounceSubscription.unsubscribe();
        };
    }, [onChange, survey]);

    useEffect(() => {
        if (!survey) {
            return;
        }
        survey.setValue('explainRiskScore', includeRiskScore);
        
    }, [includeRiskScore, survey]);

    return survey && <Survey model={survey} showCompleteButton={showCompleteButton} />;
};
